import React from 'react'
import { createRoot } from 'react-dom/client'
import { CssBaseline, ThemeProvider } from '@mui/material'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import theme from './theme'
import { AuthProvider } from './contexts/AuthContext'
import { RequestsProvider } from './contexts/RequestsContext'
import AppErrorBoundary from './components/AppErrorBoundary'

const configuredApiBaseUrl = (import.meta.env.VITE_API_BASE_URL || '').trim()
if (!import.meta.env.DEV && configuredApiBaseUrl.length === 0) {
  throw new Error('VITE_API_BASE_URL must be defined in production environment.')
}
const apiBaseUrl = configuredApiBaseUrl || ''
const rootElement = document.getElementById('root')

if (!rootElement) {
  throw new Error('Root element #root was not found')
}

createRoot(rootElement).render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <AuthProvider apiBaseUrl={apiBaseUrl}>
          <RequestsProvider>
            <AppErrorBoundary>
              <App />
            </AppErrorBoundary>
          </RequestsProvider>
        </AuthProvider>
      </BrowserRouter>
    </ThemeProvider>
  </React.StrictMode>
)

const bootLoader = document.getElementById('boot-loader')
if (bootLoader) {
  requestAnimationFrame(() => {
    bootLoader.classList.add('boot-loader--hidden')
    window.setTimeout(() => {
      bootLoader.remove()
    }, 220)
  })
}
